import { API_PREFIX } from './api/media';
import './errors';
import { isApiError } from './is-api-error';

class ApiRequestError extends Error {
  constructor(status, body) {
    super(body?.error.message ?? `Request failed with ${String(status)}`);
    this.status = status;
    this.body = body;
    this.name = "ApiRequestError";
  }
  status;
  body;
  get code() {
    return this.body?.error.code ?? "internal";
  }
  /** Field-level messages from a 400, keyed by the path the API reported. */
  get fieldErrors() {
    const out = {};
    for (const detail of this.body?.error.details ?? []) out[detail.path] = detail.message;
    return out;
  }
}
function createApiClient({ baseUrl = API_PREFIX, headers } = {}) {
  async function request(method, path, options, body) {
    const search = new URLSearchParams();
    for (const [name, value] of Object.entries(options.query ?? {})) {
      if (value !== void 0) search.set(name, String(value));
    }
    const query = search.toString();
    const response = await fetch(`${baseUrl}${path}${query === "" ? "" : `?${query}`}`, {
      method,
      headers: {
        accept: "application/json",
        ...body === void 0 ? {} : { "content-type": "application/json" },
        ...headers?.() ?? {}
      },
      ...body === void 0 ? {} : { body: JSON.stringify(body) },
      ...options.signal === void 0 ? {} : { signal: options.signal }
    });
    if (!response.ok) {
      const body2 = await response.json().catch(() => null);
      throw new ApiRequestError(response.status, isApiError(body2) ? body2 : null);
    }
    if (response.status === 204) return void 0;
    return await response.json();
  }
  return {
    get: (path, options = {}) => request("GET", path, options),
    post: (path, body, options = {}) => request("POST", path, options, body),
    patch: (path, body, options = {}) => request("PATCH", path, options, body),
    put: (path, body, options = {}) => request("PUT", path, options, body),
    remove: (path, options = {}) => request("DELETE", path, options)
  };
}

export { ApiRequestError, createApiClient };
//# sourceMappingURL=client.js.map
//# sourceMappingURL=client.js.map